import { FormEvent, ReactNode } from 'react';

interface FormProps {
  children: ReactNode;
  className?: string;
  onSubmit?: (e: FormEvent) => void;
}

const Form = ({ children, className, onSubmit }: FormProps) => {
  return (
    <form
      className={className}
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
};

export default Form;
